import React from 'react';

interface StatsCardProps {
  title: string;
  value: string | number;
  color: 'blue' | 'green' | 'red' | 'yellow'; // Ορισμός επιτρεπτών τιμών
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, color }) => {
  // Mapping των χρωμάτων σε πλήρη Tailwind classes
  const colorMap = {
    blue: 'bg-blue-100',
    green: 'bg-green-100',
    red: 'bg-red-100',
    yellow : 'bg-yellow-100',
  };

  return (
    <div className={`p-6 rounded-lg shadow-md ${colorMap[color]}`}>
      <h3 className="text-gray-600 text-sm">{title}</h3>
      <p className="text-2xl font-bold">{value}</p>
    </div>
  );
};

export default StatsCard;